import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { ChannelDiscussionService } from './channel-discussion.service';
import { ProjectsService } from 'app/_services/projects.service';


const moment = require('moment');
@Component({
  selector: 'app-channel-discussion-manager',
  templateUrl: './channel-discussion.component.html',
  styleUrls: ['./channel-discussion.component.scss']
})
export class ChannelDiscussionManagerComponent implements OnInit {

  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  sourceByTopic = "";

  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';
  notSpam = true;
  notSpam2 = false;
  typeAction = 'create';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  dateRangeRecommand: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };


  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  optionsRecommand = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.dateRangeRecommand.start,
    endDate: this.dateRangeRecommand.end
  };


  listPosts = [];
  sourceRecommand = 'facebook';
  typeSentimentPost = 'neg';

  arrayPost = [];
  ckeditorContent = '';
  showSuggestPost = false;

  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;

  currentSourceEdit = 'facebook';

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private channelDiscussionService: ChannelDiscussionService,
    private modalService: BsModalService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: true,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: true,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate = this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.channelDiscussionService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCKTL"]
    };
    this.dataTableShow = false;
    this.channelDiscussionService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }


  clickReport() {
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    if (this.projectSelected.length > 4 || this.brandSelected.length > 4) {
      this.toastrService.warning("Vui lòng chọn tối đa 4 chủ đề hoặc thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.arrayPost = [];
    // let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam2
    };
    this.channelDiscussionService.getReport({ filter: filter,index : 'full'  }).subscribe(response => {
      let data = response.data;
      if (data) {
        let facebookCount = data.aggregations.facebook.doc_count;
        let newCount = data.aggregations.news.doc_count;

        let tiktokCount = data.aggregations.tiktok.doc_count;
        let youtubeCount = data.aggregations.youtube.doc_count;
        let instagramCount = data.aggregations.instagram.doc_count;
        let linkedinCount = data.aggregations.linkedin.doc_count;

        let sentimentFacebook = {};
        let arraySentimentFacebook = data.aggregations.facebook.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentFacebook) {
          sentimentFacebook[arraySentimentFacebook[_key].key] = arraySentimentFacebook[_key].doc_count;
        }

        let sentimentNews = {};
        let arraySentimentNews = data.aggregations.news.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentNews) {
          sentimentNews[arraySentimentNews[_key].key] = arraySentimentNews[_key].doc_count;
        }

        let sentimentTiktok = {};
        let arraySentimentTiktok = data.aggregations.tiktok.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentTiktok) {
          sentimentTiktok[arraySentimentTiktok[_key].key] = arraySentimentTiktok[_key].doc_count;
        }

        let sentimentYoutube = {};
        let arraySentimentYoutube = data.aggregations.youtube.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentYoutube) {
          sentimentYoutube[arraySentimentYoutube[_key].key] = arraySentimentYoutube[_key].doc_count;
        }

        let sentimentInstagram = {};
        let arraySentimentInstagram = data.aggregations.instagram.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentInstagram) {
          sentimentInstagram[arraySentimentInstagram[_key].key] = arraySentimentInstagram[_key].doc_count;
        }

        let sentimentLinkedin = {};
        let arraySentimentLinkedin = data.aggregations.linkedin.sentimentsCount.statistic.seg.buckets;
        for (var _key in arraySentimentLinkedin) {
          sentimentLinkedin[arraySentimentLinkedin[_key].key] = arraySentimentLinkedin[_key].doc_count;
        }

        this.dataReport = {
          report_desc: "Báo cáo kênh thảo luận",
          report_type: this.typeReport,
          report_name: "Báo cáo kênh thảo luận " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCKTL", // báo cáo kênh thảo luận
          data: {
            facebookCount: facebookCount,
            newCount: newCount,
            tiktokCount: tiktokCount,
            youtubeCount:youtubeCount,
            instagramCount: instagramCount,
            linkedinCount: linkedinCount,
            sentimentNews: sentimentNews,
            sentimentFacebook: sentimentFacebook,
            sentimentYoutube: sentimentYoutube,
            sentimentTiktok : sentimentTiktok,
            sentimentInstagram: sentimentInstagram,
            sentimentLinkedin: sentimentLinkedin,

            totalSentimentFacebook: data.aggregations.facebook.sentimentsCount.statistic.doc_count,
            totalSentimentNews: data.aggregations.news.sentimentsCount.statistic.doc_count,
            totalSentimentYoutube: data.aggregations.youtube.sentimentsCount.statistic.doc_count,
            totalSentimentTiktok: data.aggregations.tiktok.sentimentsCount.statistic.doc_count,
            totalSentimentInstagram: data.aggregations.instagram.sentimentsCount.statistic.doc_count,
            totalSentimentLinkedin: data.aggregations.linkedin.sentimentsCount.statistic.doc_count,

            htmlFacebook : '',
            htmlNews : ''
          }
        }
      }
    });
    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.channelDiscussionService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.channelDiscussionService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  showRecommentPost(modalRef) {
    this.viewPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }
  
  pageChange(number) {
     this.listPosts = [];
     this.currentPageRecommand = number;
     this.viewPost();
  }

  selectedDateRecommand(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;

    
    this.optionsRecommand.startDate = this.dateRangeRecommand.start;
    this.optionsRecommand.endDate =  this.dateRangeRecommand.end;
  }

  viewPost() {
    this.listPosts = [];
    this.showSuggestPost = false;
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    // this.currentPageRecommand = 1;
    this.totalRecommandPost = 0;

    if(this.sourceRecommand == 'facebook') {
      const filterFacebook= {
        filter: {
          gte: this.dateRangeRecommand.start.valueOf(),
          lte: this.dateRangeRecommand.end.valueOf()
        },
        brands: this.brandSelected,
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
        typeSentimentPost: this.typeSentimentPost,
        type: 'facebook',
        notSpam : this.notSpam
      };
      this.channelDiscussionService.getSuggestionPost(filterFacebook).subscribe(res => {
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand)
          this.showSuggestPost = true;
        }
        else {
          this.listPosts = [];
        }
      });
    }
    if(this.sourceRecommand == 'news') {
      let filter = {
        gte: this.dateRangeRecommand.start.valueOf(),
        lte: this.dateRangeRecommand.end.valueOf(),
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
        sentiment: [this.typeSentimentPost],
        brands: this.brandSelected
      };
      this.channelDiscussionService.getArticleTopic({ filter: filter, size: 1000 }).subscribe(res => { 
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand);
          this.showSuggestPost = true;
        }
      });
    }
 
  }

  clickSaveRecommand(item) {
    
    this.arrayPost.push( {
      post : item,
      type: this.sourceRecommand
    });
  }
  clickRemoveRecommand(item) {
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].post._id == item["_source"]["docId"] || this.arrayPost[i].post._id == item["_source"]["id"]) {
        this.arrayPost.splice(i, 1);
        break;
      }
    }
  }

  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].post._id == item["_source"]["docId"] || this.arrayPost[i].post._id == item["_source"]["id"]) {
        check = true;
        break;
      }
    }
    return check;
  }

  async savePosts() {
    let htmlFacebook = '';
    let htmlNews = '';
    this.arrayPost.forEach(data => {
      if(data.type == 'facebook') {
        htmlFacebook +=  `${data.post._source.message || data.post._source.content}<br>`;
      }
      if(data.type == 'news') {
        htmlNews +=  `${data.post._source.message || data.post._source.content}<br>`;
      }
    })
    let tempDataReport = JSON.parse(JSON.stringify(this.dataReport));
    tempDataReport['data']['htmlFacebook'] = htmlFacebook;
    tempDataReport['data']['htmlNews'] = htmlNews;
    this.dataReport = {};
    this.dataReport = tempDataReport;

    this.modalRef.hide();
  }

  clickEditReportItem(item,modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.currentSourceEdit = 'facebook';
    this.ckeditorContent = this.currentConfigItem['data'].htmlFacebook
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }
  onCurrentSourceEditChange(source) {
    if(source == 'facebook') {
      this.ckeditorContent = this.currentConfigItem['data'].htmlFacebook;
    } 
    if(source == 'news') {
      this.ckeditorContent = this.currentConfigItem['data'].htmlNews
    }

  }

  saveEditPost(){
    if(this.currentSourceEdit == 'facebook') {
      this.currentConfigItem['data'].htmlFacebook = this.ckeditorContent;
    }

    if(this.currentSourceEdit == 'news') {
      this.currentConfigItem['data'].htmlNews = this.ckeditorContent;
    }


    this.channelDiscussionService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {
      if(res.success){
        this.toastrService.success('Update thành công','Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }


  onItemSelect(item: any, type: any) {
    type = [item];
  }
  OnItemDeSelect(item: any, type: any) {
    type = []
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/channel-discussion/channel-discussion.component.ts